'use strict';

/**
 * View for group actions
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var GroupEditModalView = require('modules/community/views/layout/group-edit-modal');

var template = require('modules/community/templates/partials/group-actions.hbs');

var GroupActionsView = LayoutView.extend({
    template: template,

    className: 'actions group-actions',

    ui: {
        'showActions': '[data-action="show-actions"]',
        'actionLayer': '.action-layer',
        'renameGroup': '[data-action="rename-group"]',
        'changeUsersGroup': '[data-action="change-users-group"]',
        'leaveGroup': '[data-action="leave-group"]',
        'deleteGroup': '[data-action="delete-group"]',
    },

    events: {
        'click @ui.showActions': 'showActions',
        'click @ui.renameGroup': 'editGroup',
        'click @ui.changeUsersGroup': 'editGroup',
        'click @ui.leaveGroup': 'leaveGroup',
        'click @ui.deleteGroup': 'deleteGroup',
    },

    modelEvents: {
        'change': 'modelChanged',
    },

    groupMemberLimit: 5,

    templateHelpers: {
        t: function() {
            if (this.model.get('type') === 'broadcast') {
                var translationKey = arguments[0];
                var broadcastLabels = {
                    'community::group:action:rename': 'community::broadcast:action:rename',
                    'community::group:action:change-users': 'community::broadcast:action:change-users',
                    'community::group:action:delete': 'community::broadcast:action:delete',
                };

                if (_.has(broadcastLabels, translationKey)) {
                    arguments[0] = broadcastLabels[translationKey];
                }
            }

            return App.t.apply(App, arguments);
        },
    },

    showActions: function(event) {
        event.preventDefault();
        this.ui.actionLayer.closest('.conversation-header').addClass('show-actions');
        this.ui.actionLayer.addClass('is-visible');

        // Close actions overlay on next click
        setTimeout(function(){
            $('body').one('click', this.hideActions.bind(this));
        }.bind(this), 0)
    },

    hideActions: function() {
        if (this.ui.actionLayer.removeClass) {
            this.ui.actionLayer.removeClass('is-visible');
            this.ui.actionLayer.closest('.conversation-header').removeClass('show-actions');
        }
    },

    editGroup: function() {
        var groupEditModalView = new GroupEditModalView({
            model: this.model,
        });

        var options = {
            additionalClassName: 'modal-center modal-restriction modal-community-group-edit',
            additionalBgClassName: 'light-bg',
        };

        App.addModal(groupEditModalView, options);
    },

    leaveGroup: function(event) {
        if (!window.confirm(App.t('community::group:action:confirm-leave', {name: _.escape(this.model.get('name'))}))) {
            return;
        }

        App.radio('community').execute('leave:group', this.model);

        this.trigger('group:left');
    },

    deleteGroup: function(event) {
        var confirmMessageKey = this.model.get('type') === 'broadcast' ? 'community::broadcast:action:confirm-delete' : 'community::group:action:confirm-delete';
        if (!window.confirm(App.t(confirmMessageKey, {name: _.escape(this.model.get('name'))}))) {
            return;
        }

        App.radio('community').execute('delete:group', this.model);

        this.trigger('group:deleted');
    },

    modelChanged: function() {
        if (this.isDestroyed) { return; }

        this.render();
    },
});

module.exports = GroupActionsView;